import React from "react";

import Image1 from '../images/justyna-pluciennikowska.webp';

import '../css/designer.css';

import useDictionary from '../hooks/useDictionary';

export default function OurDesignerStory() {

    const dictionary = useDictionary();

    const TextWithBreaks = ({ text }) => (
        <>
            {text.split('\n').map((line, i, arr) => (
            <React.Fragment key={i}>
                {line}
                {i < arr.length - 1 && <br />}
            </React.Fragment>
            ))}
        </>
    );

    return (

        <section>

            <div className="designer-story">
                <div className="photo">
                    <img alt="Justyna Pluciennikowska - Negativ Brand" src={Image1} />
                </div>

                <div className="content">

                    <div className="sub-header">{dictionary.DESIGNER_HEADER}</div>

                    <div className="name">
                        Justyna<br />Płuciennikowska
                    </div>
                    <div className="text">
                        <p>{dictionary.DESIGNER_P1}</p>
                        <p>{dictionary.DESIGNER_P2}<br />{dictionary.DESIGNER_P3}</p>
                    </div>
                    <div className="quote">
                        "<TextWithBreaks text={dictionary.DESIGNER_QUOTE} />"
                    </div>
                </div>
            </div>

        </section>

    )

}